import Input from "../components/General/Input"
import Button from "../components/General/Button"
import { useFormik } from "formik"
import { useRouter } from "next/router"
import { useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import PortalLogin from "../validations/PortalLogin";

function LoginComponent(props : any) {
    const initialValues = {
        email: '',
        password: '',
        user_type: 'seller',
    }
    
    const [buttonLoader, setButtonLoader]: any = useState(false);
    const { values, errors, handleSubmit, handleBlur, handleChange, touched, resetForm } = useFormik({
        initialValues: initialValues,
        validationSchema : PortalLogin,
        onSubmit: (values, action) => {
            props.onLogin(values, action.resetForm, setButtonLoader)
        }
    });

    return (
        <div style={{ background: '#F7F7F7' }} className="h-[100vh] flex items-center justify-center">
            <div className="inputs bg-white p-[50px] w-[100%] md:w-[50%] lg:w-[30%] rounded drop-shadow-xl shadow-xl">
                <div className="logo flex items-center justify-between mb-10 gap-3">
                    <img src="/logo.png" alt="" className="w-[30%] lg:w-[40%]" />
                    <h1 className="text-3xl border-l-2 border-theme-black pl-2"> 
                        { props.portalHeading }
                    </h1>
                </div>

                <div className="inputs">
                    <form onSubmit={handleSubmit}>
                        <div>
                            <Input
                                label='Email'
                                labelColor='#444444'
                                labelProperties='opacity-50 text-[15px]'
                                placeholder='Enter Email'
                                properties='border border-[#707070 50%] rounded h-11 placeholder:text-sm'
                                onChange={handleChange}
                                name='email'
                                value={values.email}
                                onBlur={handleBlur}
                                error={errors.email}
                                touched={touched.email}
                                type="email"
                            />
                        </div>

                        <div className="mt-10">
                            <Input
                                label='password'
                                labelColor='#444444'
                                labelProperties='opacity-50 text-[15px]'
                                placeholder='Enter Password'
                                properties='border border-[#707070 50%] rounded h-11 placeholder:text-sm'
                                onChange={handleChange}
                                name='password'
                                value={values.password}
                                onBlur={handleBlur}
                                error={errors.password}
                                touched={touched.password}
                                type="password"
                            />
                        </div>

                        <Button type="submit" styles='bg-theme-orange text-white w-full mt-10 h-12' loader = {buttonLoader}> 
                            Login 
                        </Button>
                    </form>
                </div>
            </div>
        </div>
    )
}

LoginComponent.SellerLayout = (page: any) => page

export default LoginComponent